import { createSlice } from '@reduxjs/toolkit';

type initialState = {
  branchList?: any;
};

const initialStateValue: initialState = {
  branchList: undefined,
};
export const branchReducer = createSlice({
  name: 'branch',
  initialState: initialStateValue,
  reducers: {
    setAllBranchWithoutSearch: (state, { payload }) => {
      state.branchList = payload;
    },
  },
});

export const { setAllBranchWithoutSearch } = branchReducer.actions;
export default branchReducer.reducer;
